import { render } from "./QuickReminderMenu.vue?vue&type=template&id=aa448642&scoped=true"
import script from "./QuickReminderMenu.vue?vue&type=script&lang=js"
export * from "./QuickReminderMenu.vue?vue&type=script&lang=js"

import "./QuickReminderMenu.vue?vue&type=style&index=0&id=aa448642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa448642"]])

export default __exports__